import { useForm } from "react-hook-form";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {
  FIELD_REQUIRED,
  MODAL_CANVA_IMAGE_CONFIG_CANCEL_BUTTON,
  MODAL_GOOGLE_DRIVE_ACCOUNT_CONFIRM_BUTTON,
  MODAL_GOOGLE_DRIVE_ACCOUNT_LABEL,
  MODAL_GOOGLE_DRIVE_ACCOUNT_TITLE,
} from "../../i18n/keysTranslations";
import { useTranslationApp } from "../../lib/i18next";
import ModalBasicLayout from "./ModalBasicLayout";
import ContainerModalActions from "../Containers/ContainerModalActions";
import SelectGoogleDriveAccountWithConnect from "../GoogleDrive/SelectGoogleDriveAccountWithConnect";

const ModalSelectGoogleDriveAccount = ({
  modalOpen,
  onCloseModal = () => {},
  onConfirm = () => {},
}) => {
  const { t } = useTranslationApp();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      googleDriveAccount: null,
    },
  });

  const onSubmit = ({ googleDriveAccount }) => {
    const integrationID =
      googleDriveAccount?.id || googleDriveAccount?.integrationID;
    if (!integrationID) return;

    onConfirm({ integrationID });
  };

  return (
    <ModalBasicLayout
      modalOpen={modalOpen}
      onCloseModal={onCloseModal}
      ariaLabel={t(MODAL_GOOGLE_DRIVE_ACCOUNT_TITLE)}
      title={t(MODAL_GOOGLE_DRIVE_ACCOUNT_TITLE)}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 3, mb: 3 }}>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            {t(MODAL_GOOGLE_DRIVE_ACCOUNT_LABEL)}
          </Typography>
          <SelectGoogleDriveAccountWithConnect
            control={control}
            name="googleDriveAccount"
            fullWidth
            variant="filled"
            errors={errors}
            rules={{
              required: {
                value: true,
                message: t(FIELD_REQUIRED),
              },
            }}
          />
        </Box>
      </Box>
      <ContainerModalActions
        hasPadding={false}
        propsPrimaryButton={{
          showButton: true,
          text: MODAL_GOOGLE_DRIVE_ACCOUNT_CONFIRM_BUTTON,
          onClick: handleSubmit(onSubmit),
        }}
        propsSecondaryButton={{
          showButton: true,
          text: MODAL_CANVA_IMAGE_CONFIG_CANCEL_BUTTON,
          onClick: onCloseModal,
        }}
      />
    </ModalBasicLayout>
  );
};

export default ModalSelectGoogleDriveAccount;
